import { SceneScheduleDay } from './scene-schedule-day.model';

export class SceneScheduleDaysWithCount
{
    constructor(json: any = null)
    {
        if (json)
        {
            if (json.Count)
            {
                this.Count = json.Count;
            }

            if (json.Days)
            {
                this.Days = [];
                json.Days.forEach(day =>
                {
                    this.Days.push(new SceneScheduleDay(day));
                });
            }

            return;
        }

        this.Days = [];
        this.Count = 0;
    }

    public Days: SceneScheduleDay[];
    public Count: number;
}
